import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SnapshotService } from '../Services/snapshot.service';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import * as _ from 'lodash';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { AlertMessageModel } from 'src/app/common/models/common.model';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';

@Component({
  selector: 'app-visual-select',
  templateUrl: './visual-select.component.html',
  styleUrls: ['./visual-select.component.css']
})
export class VisualSelectComponent {

  @Input() show: boolean = true;
  @Input() widgetList: any;
  @Output() triggerDrop = new EventEmitter();
  @Input() disabledrag: boolean = true;
  @Output() newWidgetList = new EventEmitter();
  @Input() deleteFlag: boolean = false;
  @Input() maxheightofbody:string="22rem";
  @Output() duplicateWidgetAdded = new EventEmitter();
  @Output() editClicked=new EventEmitter();

  showErrorPopUp = false;
  popUpMessage = '';
  errorheaderTitle = '';
  isPopShow:Boolean = false;

  constructor(
    private _configService: SnapshotService,
    private _configCustomService: CustomsnapshotService,
    private clientDetails: SnapshotSharedVariablesService,
    private cdref: ChangeDetectorRef,
    private _alertService: AlertMessageService
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['widgetList'] && !changes['widgetList'].firstChange) {
    if (changes['widgetList']) {
      // Handle the change in widgetList here if needed
      //this.BindCustomMetricSoftDelete();
    }
  }

  // BindCustomMetricSoftDelete(){
  //   let customMetrics = this._configCustomService.widgetCustomMetrics;
  //   let widgetDetails = this._configCustomService.widgetSaveObjectCustom;

  //   if( customMetrics != undefined && customMetrics !=null && customMetrics.length > 0 ){
  //     customMetrics = customMetrics.filter((metric : any) => metric.soft_delete == "1");

  //     let widgetContainSoftDeleteMetrics : any[] = [];
  //     if(widgetDetails.length > 0 ){
  //       widgetDetails.forEach((widget:any) => {
  //         widget.snapshotType.forEach((snapshots:any) => {
  //           snapshots.section.forEach((sec : any) => {
  //             sec.subsection.forEach((subSec : any) => {
  //               subSec.widget_detail.forEach((wid:any) => {
  //                 wid.metric.forEach((metric :any) =>{
  //                   metric.metric_value.forEach((metricValue : any) => {
  //                     let metrics = JSON.parse(metricValue);
  //                     let prevCount = metrics.length;
  //                     //metrics = metrics.filter( (it:any) => !customMetrics.some((remove:any) =>  remove.selection_name == it.option));
                      
  //                     metrics?.forEach((mt : any) => {
  //                       let data = customMetrics?.filter((remove:any) =>  remove.selection_name == mt.option);
  //                       if(data.length > 0 ){
  //                         widgetContainSoftDeleteMetrics.push({
  //                           widgetName :wid.widget_name,
  //                           metric : mt.option
  //                         })
  //                       }
  //                     })                      
  //                   })
  //                 })
  //               })
  //             })
  //           })
  //         })
  //       })
  //     }


  //     if(widgetContainSoftDeleteMetrics.length > 0 && this.widgetList != undefined && this.widgetList != null){
  //       let isSoftDeleteAvailable = false
  //       this.widgetList = this.widgetList.map((widget:any) => {
  //         let wid = widgetContainSoftDeleteMetrics.filter((m:any) => m.widgetName == widget.widgetName);
  //         if(wid.length > 0){
  //           widget.isSoftDelete = true;
  //           isSoftDeleteAvailable = true;
  //         }else{
  //           widget.isSoftDelete = false;
  //         }

  //         return widget;
  //       })

  //       // if(isSoftDeleteAvailable){
  //       //   let message =  "If this metric was configured in any existing widget, please update the metric in the Widget Library. Affected widgets will be highlighted in Red Border for easy identification."
  //       //   this.showMessagePopup(message);
  //       // }
  //     }

  //     if(customMetrics.length > 0 && widgetContainSoftDeleteMetrics.length > 0 ){
  //       let UpdatecustomMetrics = JSON.parse(JSON.stringify(this._configCustomService.widgetCustomMetrics));
  //       let isSoftDeleteAvailable = false;
  //       UpdatecustomMetrics = UpdatecustomMetrics?.map((metric:any) => {
  //         if( metric.soft_delete == "1"){
  //           let isDataAvailable = widgetContainSoftDeleteMetrics.filter((m:any) => m.metric == metric.selection_name);
  //           if(isDataAvailable.length == 0 ){
  //             metric.soft_delete = "2";
  //             //isSoftDeleteAvailable = true;
  //           } 
  //         }
  //         return metric;
  //       });

  //       if(isSoftDeleteAvailable){
  //         this._configCustomService.updateCustomMetricSnapShotWidgetLibrary(UpdatecustomMetrics).subscribe(
  //           (response: any) => {
  //             if (response.Data != "") {
                
  //             }
  //             else {
  //             }
  //           }
  //         );
  //       }
  //     }
  //   }
  // }

  // showMessagePopup(message:string="Are you show", headerTxt:string = "Information") : void {
  //   const alertObj: AlertMessageModel = {
  //     header: headerTxt,
  //     message: message,
  //     show: true,
  //   };
  //   this._alertService.showAlert(alertObj);
  // }

  onCloseIconClick(closePopUp: string): void {
    if (closePopUp == 'false') {
      this.showErrorPopUp = false;
    }
  }
  drop(event: CdkDragDrop<any>, WidgetDetail: any) {
    (event as any)["detail"] = WidgetDetail;
    this.triggerDrop.emit(event);

  }
  showDeletePopup = false;
  deleteVisual: any;
  confirmDelete: any;
  widgetDetails: any;
  delete(widget: any) {
    this.showDeletePopup = true;
    this.deleteVisual = widget;
  }
  receivedDeleteConfirmation(data: any) {
    this.showDeletePopup = false;
    if (data == 'yes') {
      this.confirmDelete = this.widgetList.filter((list: any) => {
        return list !== this.deleteVisual;
      });
      // this.newWidgetList.emit(this.confirmDelete);
      let chartname = this.deleteVisual.visualization ? this.deleteVisual.visualization : '';
      this._configService.widgetNametoDelete = chartname;
      this.newWidgetList.emit(this.confirmDelete);
    }
  }

  duplicate(widget: any) {
    let countofWidgets = 0;
    if ((this._configCustomService.widgetSaveObjectCustom.length != 0 && this._configCustomService.widgetSaveObjectCustom.length > 0)) {
      //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
      this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
      if (this.widgetDetails.length != undefined) {
        let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
        if (snaphottypes) {
          let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
          if (snapshotType) {
            let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
            if (section) {
              let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
              if (subsection) {
                // Clone the original widget
                countofWidgets = subsection.widget_detail?.filter((w:any)=>w.widgetParentChartType!="LineChart").length;
                if (countofWidgets < this._configCustomService.maxWidgetSelection) {
                  let widgetdata = _.cloneDeep(subsection.widget_detail.find((sw: any) => sw.widget_name === widget.widgetName));
                  if (widgetdata) {
                    widgetdata.previewChartPostion=0;
                    // Find the index of the original widget
                    let widgetindex = subsection.widget_detail.findIndex((sw: any) => sw.widget_name === widget.widgetName);

                    // Base widget name without _Copy or version
                    let baseWidgetName = widget.widgetName;

                    // Get all existing widgets that start with the baseWidgetName followed by "_Copy"
                    let existingCopies = subsection.widget_detail.filter((element: any) =>
                      element.widget_name.startsWith(baseWidgetName + "_Copy")
                    );

                    // Check if there are any existing copies
                    if (existingCopies.length > 0) {
                      let maxVersion = 0;

                      // Iterate through each existing copy and extract its version number if it exists
                      existingCopies.forEach((element: any) => {
                        const match = element.widget_name.match(/\_Copy(?: \((\d+)\))?$/); // Match "_Copy" or "_Copy (n)"
                        if (match && match[1]) {
                          const version = parseInt(match[1], 10);
                          if (version > maxVersion) {
                            maxVersion = version;
                          }
                        }
                      });

                      // If there are already versions with numbers, increment the max version
                      widgetdata.widget_name = `${baseWidgetName}_Copy (${maxVersion + 1})`;
                    } else {
                      // If no copies exist, set it as the first copy with just "_Copy"
                      widgetdata.widget_name = `${baseWidgetName}_Copy`;
                    }

                    // Insert the cloned widget immediately after the original widget
                    subsection.widget_detail.splice(widgetindex + 1, 0, widgetdata);
                  }
                  this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustom[0], this._configCustomService.selectedSection, (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "")? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name)
                  this.cdref.detectChanges();
                  this.duplicateWidgetAdded.emit(true);
                }
                else{
                  this.showErrorPopUp=true;
                  this.errorheaderTitle="Info";
                  this.popUpMessage = "Maximum Widget Limit of 16 Visuals is reached! Please delete a Visual to configure another";   
                 }
              }


            }

          }
        }
      }
    }

  }

  edit(widget:any){
    this.editClicked.emit(widget);
  }

}
